import { type ReactNode, useState } from "react";

import { InfoIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "~/components/ui/tooltip";

export function InfoTooltip({ content }: { content: ReactNode }) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isClicked, setIsClicked] = useState<boolean>(false);

    return (
        <TooltipProvider>
            <Tooltip delayDuration={0} open={isOpen || isClicked} onOpenChange={setIsOpen}>
                <TooltipTrigger
                    onMouseLeave={() => setIsClicked(false)}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        setIsClicked(!isClicked)
                    }}
                    aria-label="Additional information">
                    <InfoIcon width="1.1em" height="1.1em" className="info-icon" />
                </TooltipTrigger>
                <TooltipContent className="max-w-60 w-full">
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
